export default __webpack_public_path__ + "static/media/logo.a36afdd6.png";